import { ax } from 'src/client'
import { ACCOUNTS, GET_POSITIONS_URL } from './serviceURLS'

export const getPositions = (accountId, params) => {
  return ax.get(GET_POSITIONS_URL.replace(':id', accountId), { params })
}

export const getAccounts = (params) => {
  return ax.get(ACCOUNTS, { params })
}
